/**
 * Route Configuration
 * Centralized route constants for the MyWorkAI application
 */

export const ROUTES = {
  // Public routes
  HOME: '/',
  
  // Auth routes
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    VERIFY_EMAIL: '/verify-email',
  },
  
  // Student routes
  STUDENT: {
    DASHBOARD: '/student/dashboard',
    HOMEWORK: '/student/homework',
    HOMEWORK_DETAIL: '/student/homework/:assignmentId',
    HOMEWORK_SUBMIT: '/student/homework/:assignmentId/submit',
    CALENDAR: '/student/calendar',
    TIMETABLE: '/student/timetable',
    SUBMISSIONS: '/student/submissions',
    SUBMISSION_DETAIL: '/student/submissions/:submissionId',
    HKDSE_ICT: '/student/learning/hkdse-ict',
    HKDSE_ICT_TOPIC: '/student/learning/hkdse-ict/:topicSlug',
    HKDSE_ICT_NOTES: '/student/learning/hkdse-ict-notes',
    HKDSE_ICT_NOTES_TOPIC: '/student/learning/hkdse-ict-notes/:topicSlug',
    HKDSE_ICT_YEARS: '/student/learning/hkdse-ict-years',
    HKDSE_ICT_YEARS_TOPIC: '/student/learning/hkdse-ict-years/:topicSlug',
    PDF_CABINET: '/student/learning/pdf-cabinet',
    PDF_CABINET_FILE: '/student/learning/pdf-cabinet/:fileSlug',
    MATHS_PDF_CABINET: '/student/learning/maths-pdf-cabinet',
    MATHS_PDF_CABINET_FILE: '/student/learning/maths-pdf-cabinet/:fileSlug',
    SCHOOL_MATHS_PDF_CABINET: '/student/learning/school-maths-pdf-cabinet',
    SCHOOL_MATHS_PDF_CABINET_FILE: '/student/learning/school-maths-pdf-cabinet/:fileSlug',
    HEEP_YUNN: '/student/learning/heep-yunn',
    HEEP_YUNN_TOPIC: '/student/learning/heep-yunn/:topicSlug',
    HEEP_YUNN_F1: '/student/learning/heep-yunn-f1',
    HEEP_YUNN_F1_TOPIC: '/student/learning/heep-yunn-f1/:topicSlug',
    GOOD_HOPE: '/student/learning/good-hope',
    GOOD_HOPE_TOPIC: '/student/learning/good-hope/:topicSlug',
    GOOD_HOPE_F1: '/student/learning/good-hope-f1',
    GOOD_HOPE_F1_TOPIC: '/student/learning/good-hope-f1/:topicSlug',
    HKDSE_MATHS_P1: '/student/learning/hkdse-maths-p1',
    HKDSE_MATHS_P1_ANALYSIS: '/student/learning/hkdse-maths-p1/analysis',
    HKDSE_MATHS_P1_LQ_SKILL_BOOKS: '/student/learning/hkdse-maths-p1/lq-skill-books',
    HKDSE_MATHS_P1_TOPIC: '/student/learning/hkdse-maths-p1/:topicSlug',
    EXAMRIGHT_P1: '/student/learning/examright-p1',
    EXAMRIGHT_P1_TOPIC: '/student/learning/examright-p1/:topicSlug',
    EXAMRIGHT_P2_MC: '/student/learning/examright-p2-mc',
    EXAMRIGHT_P2_MC_TOPIC: '/student/learning/examright-p2-mc/:topicSlug',
    DSERIGHT_P1: '/student/learning/dseright-p1',
    DSERIGHT_P1_ANALYSIS: '/student/learning/dseright-p1/analysis',
    DSERIGHT_P1_LQ_SKILL_BOOKS: '/student/learning/dseright-p1/lq-skill-books',
    DSERIGHT_P1_TOPIC: '/student/learning/dseright-p1/:topicSlug',
    DSERIGHT_P2_MC: '/student/learning/dseright-p2-mc',
    DSERIGHT_P2_MC_ANALYSIS: '/student/learning/dseright-p2-mc/analysis',
    DSERIGHT_P2_MC_SKILL_BOOKS: '/student/learning/dseright-p2-mc/mcq-skill-books',
    DSERIGHT_P2_MC_TOPIC: '/student/learning/dseright-p2-mc/:topicSlug',
    HKDSE_MATHS_P2: '/student/learning/hkdse-maths-p2',
    HKDSE_MATHS_P2_ANALYSIS: '/student/learning/hkdse-maths-p2/analysis',
    HKDSE_MATHS_P2_MCQ_SKILL_BOOKS: '/student/learning/hkdse-maths-p2/mcq-skill-books',
    HKDSE_MATHS_P2_TOPIC: '/student/learning/hkdse-maths-p2/:topicSlug',
    HKDSE_MATHS_P1_BY_TOPICS: '/student/learning/hkdse-maths-p1-topics',
    HKDSE_MATHS_P1_BY_TOPICS_TOPIC: '/student/learning/hkdse-maths-p1-topics/:topicSlug',
    HKDSE_MATHS_P2_BY_TOPICS: '/student/learning/hkdse-maths-p2-topics',
    HKDSE_MATHS_P2_BY_TOPICS_TOPIC: '/student/learning/hkdse-maths-p2-topics/:topicSlug',
    EXAMS: '/student/exams',
    EXAM_DETAIL: '/student/exams/:examId',
    TAKE_EXAM: '/student/exams/:examId/take',
    STUDYCARDS: '/student/studycards',
    STUDYCARDS_ANALYSIS: '/student/studycards/analysis',
    STUDYCARD_TOPIC: '/student/studycards/topics/:topicSlug',
    STUDYCARD_EDIT: '/student/studycards/:packId/edit',
    STUDYCARD_DETAIL: '/student/studycards/:packId',
    STUDYCARD_STUDY: '/student/studycards/:packId/study',
    RESULTS: '/student/results',
    RESULT_DETAIL: '/student/results/:attemptId',
    PROGRESS: '/student/progress',
    PROFILE: '/student/profile',
    SETTINGS: '/student/settings',
  },
  
  // Teacher routes
  TEACHER: {
    DASHBOARD: '/teacher/dashboard',
    HOMEWORK: '/teacher/homework',
    HOMEWORK_CREATE: '/teacher/homework/create',
    HOMEWORK_EDIT: '/teacher/homework/:assignmentId/edit',
    HOMEWORK_DETAIL: '/teacher/homework/:assignmentId',
    EXAMS: '/teacher/exams',
    EXAM_CREATE: '/teacher/exams/create',
    EXAM_EDIT: '/teacher/exams/:examId/edit',
    EXAM_DETAIL: '/teacher/exams/:examId',
    EXAM_ANALYTICS: '/teacher/exams/:examId/analytics',
    STUDYCARDS: '/teacher/studycards',
    STUDYCARDS_ANALYSIS: '/teacher/studycards/analysis',
    STUDYCARD_TOPIC: '/teacher/studycards/topics/:topicSlug',
    STUDYCARD_EDIT: '/teacher/studycards/:packId/edit',
    STUDYCARD_STUDY: '/teacher/studycards/:packId/study',
    API_TESTER: '/teacher/api-tester',
    DSERIGHT_HTML_EDITOR: '/teacher/dseright-html-editor',
    QUESTIONS: '/teacher/questions',
    QUESTION_BANK_EDITOR: '/teacher/question-bank-editor',
    QUESTION_BANK_EDITOR_TABLE: '/teacher/question-bank-editor/:tableName',
    CLASSES: '/teacher/classes',
    CLASS_DETAIL: '/teacher/classes/:classId',
    TIMETABLE: '/teacher/timetable',
    GRADING: '/teacher/grading',
    ANALYTICS: '/teacher/analytics',
    PROFILE: '/teacher/profile',
    SETTINGS: '/teacher/settings',
  },
  
  // Error routes
  ERRORS: {
    NOT_FOUND: '/404',
    UNAUTHORIZED: '/401',
    FORBIDDEN: '/403',
    SERVER_ERROR: '/500',
  },
};

/**
 * Helper function to generate dynamic routes
 */
export const generateRoute = (route, params = {}) => {
  let path = route;
  Object.keys(params).forEach((key) => {
    path = path.replace(`:${key}`, params[key]);
  });
  return path;
};

/**
 * Route groups for navigation
 */
export const NAV_GROUPS = {
  STUDENT: [
    { path: ROUTES.STUDENT.DASHBOARD, label: 'Dashboard', icon: 'LayoutDashboard' },
    { path: ROUTES.STUDENT.HOMEWORK, label: 'My Homework', icon: 'BookOpen' },
    { path: ROUTES.STUDENT.EXAMS, label: 'My Exams', icon: 'FileText' },
    { path: ROUTES.STUDENT.STUDYCARDS, label: 'My StudyCards', icon: 'Layers' },
    { path: ROUTES.STUDENT.STUDYCARDS_ANALYSIS, label: 'StudyCards Analysis', icon: 'BarChart3' },
    { path: ROUTES.STUDENT.RESULTS, label: 'Results', icon: 'Award' },
    { path: ROUTES.STUDENT.PROGRESS, label: 'Progress', icon: 'TrendingUp' },
    { path: ROUTES.STUDENT.CALENDAR, label: 'Calendar', icon: 'Calendar' },
    { path: ROUTES.STUDENT.TIMETABLE, label: 'Timetable', icon: 'CalendarDays' },
    { path: ROUTES.STUDENT.SUBMISSIONS, label: 'Submissions', icon: 'FileCheck' },
    { path: ROUTES.STUDENT.HKDSE_ICT, label: 'HKDSE ICT', icon: 'Monitor' },
    { path: ROUTES.STUDENT.HKDSE_ICT_NOTES, label: 'HKDSE ICT Notes', icon: 'StickyNote' },
    { path: ROUTES.STUDENT.HKDSE_ICT_YEARS, label: 'HKDSE ICT By Years', icon: 'CalendarRange' },
    { path: ROUTES.STUDENT.HEEP_YUNN, label: 'Heep Yunn', icon: 'School' },
    { path: ROUTES.STUDENT.HEEP_YUNN_F1, label: 'Heep Yunn F1 Maths', icon: 'GraduationCap' },
    { path: ROUTES.STUDENT.GOOD_HOPE, label: 'Good Hope', icon: 'School' },
    { path: ROUTES.STUDENT.GOOD_HOPE_F1, label: 'Good Hope F1 Maths', icon: 'GraduationCap' },
    { path: ROUTES.STUDENT.HKDSE_MATHS_P1, label: 'HKDSE Maths Paper 1', icon: 'Calculator' },
    { path: ROUTES.STUDENT.EXAMRIGHT_P1, label: 'ExamRight Paper 1', icon: 'Layers' },
    { path: ROUTES.STUDENT.EXAMRIGHT_P2_MC, label: 'ExamRight Paper 2 MC', icon: 'CircleDot' },
    { path: ROUTES.STUDENT.DSERIGHT_P1, label: 'DSERight Paper 1', icon: 'Layers' },
    { path: ROUTES.STUDENT.DSERIGHT_P1_LQ_SKILL_BOOKS, label: 'DSE LQ Skill Books', icon: 'BookOpen' },
    { path: ROUTES.STUDENT.DSERIGHT_P2_MC, label: 'DSERight Paper 2 MC', icon: 'CircleDot' },
    { path: ROUTES.STUDENT.DSERIGHT_P2_MC_SKILL_BOOKS, label: 'DSE MC Skill Books', icon: 'BookOpen' },
    { path: ROUTES.STUDENT.HKDSE_MATHS_P2, label: 'HKDSE Maths Paper 2', icon: 'ListChecks' },
    { path: ROUTES.STUDENT.HKDSE_MATHS_P1_BY_TOPICS, label: 'HKDSE Maths Paper 1 By Topics', icon: 'Box' },
    { path: ROUTES.STUDENT.HKDSE_MATHS_P2_BY_TOPICS, label: 'HKDSE Maths Paper 2 By Topics', icon: 'Box' },
    { path: ROUTES.STUDENT.PDF_CABINET, label: 'PDF File Cabinet', icon: 'Archive' },
    { path: ROUTES.STUDENT.MATHS_PDF_CABINET, label: 'Maths PDF File Cabinet', icon: 'Library' },
    {
      path: ROUTES.STUDENT.SCHOOL_MATHS_PDF_CABINET,
      label: 'School Maths PDF File Cabinet',
      icon: 'Building2',
    },
    { path: ROUTES.STUDENT.PROFILE, label: 'Profile', icon: 'User' },
    { path: ROUTES.STUDENT.SETTINGS, label: 'Settings', icon: 'Settings' },
  ],
  TEACHER: [
    { path: ROUTES.TEACHER.DASHBOARD, label: 'Dashboard', icon: 'LayoutDashboard' },
    { path: ROUTES.TEACHER.HOMEWORK, label: 'Homework', icon: 'BookOpen' },
    { path: ROUTES.TEACHER.EXAMS, label: 'My Exams', icon: 'FileText' },
    { path: ROUTES.TEACHER.STUDYCARDS, label: 'My StudyCards', icon: 'Layers' },
    { path: ROUTES.TEACHER.STUDYCARDS_ANALYSIS, label: 'StudyCards Analysis', icon: 'BarChart3' },
    { path: ROUTES.TEACHER.API_TESTER, label: 'CORS API Tester', icon: 'Terminal', adminOnly: true },
    {
      path: ROUTES.TEACHER.DSERIGHT_HTML_EDITOR,
      label: 'DSERight HTML Editor',
      icon: 'Code2',
      adminStaffOnly: true,
    },
    {
      path: ROUTES.TEACHER.QUESTIONS,
      label: 'Questions',
      icon: 'HelpCircle',
      children: [
        { path: ROUTES.TEACHER.QUESTION_BANK_EDITOR, label: 'Question Bank Editor', icon: 'Edit' },
      ],
    },
    { path: ROUTES.TEACHER.CLASSES, label: 'Classes', icon: 'Users' },
    { path: ROUTES.TEACHER.TIMETABLE, label: 'Timetable', icon: 'CalendarDays' },
    { path: ROUTES.TEACHER.GRADING, label: 'Grading', icon: 'ClipboardCheck' },
    { path: ROUTES.TEACHER.ANALYTICS, label: 'Analytics', icon: 'BarChart3' },
    { path: ROUTES.STUDENT.EXAMRIGHT_P1, label: 'ExamRight Paper 1', icon: 'Layers' },
    { path: ROUTES.STUDENT.EXAMRIGHT_P2_MC, label: 'ExamRight Paper 2 MC', icon: 'CircleDot' },
    { path: ROUTES.STUDENT.DSERIGHT_P1, label: 'DSERight Paper 1', icon: 'Layers' },
    { path: ROUTES.STUDENT.DSERIGHT_P1_LQ_SKILL_BOOKS, label: 'DSE LQ Skill Books', icon: 'BookOpen' },
    { path: ROUTES.STUDENT.DSERIGHT_P2_MC, label: 'DSERight Paper 2 MC', icon: 'CircleDot' },
    { path: ROUTES.STUDENT.DSERIGHT_P2_MC_SKILL_BOOKS, label: 'DSE MC Skill Books', icon: 'BookOpen' },
    { path: ROUTES.TEACHER.PROFILE, label: 'Profile', icon: 'User' },
    { path: ROUTES.TEACHER.SETTINGS, label: 'Settings', icon: 'Settings' },
  ],
};

export default ROUTES;

